import { render } from "./TransactionsView.vue?vue&type=template&id=0fc3f94a"
import script from "./TransactionsView.vue?vue&type=script&lang=js"
export * from "./TransactionsView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__